
import CILocalEconomyDashboard from "../pages/dashboard/CollegeInsight/1_CILocalEconomyDashboard"
import RegionalContextDashboard from "../pages/dashboard/CollegeInsight/2_RegionalContextDashboards"
import CollegeContextDashboard from "../pages/dashboard/CollegeInsight/3_CollegeContextDashboards"
import SSAAnalysisDashboard from "../pages/dashboard/CollegeInsight/4_SSAAnalysisDashboards"
import EILocalEconomyDashboard  from "../pages/dashboard/EconomyInsight/1_EILocalEconomyDashboard"
import BenchmarkAnalysisDashboard from "../pages/dashboard/EconomyInsight/2_BenchmarkAnalysisDashboard"
import IndustryAnalysisDashboard from "../pages/dashboard/EconomyInsight/3_IndustryAnalysisDashboard"



export const DashboardMapping = {
    private: {
        "CI_1": CILocalEconomyDashboard,
        "CI_2": RegionalContextDashboard,
        "CI_3": CollegeContextDashboard,
        "CI_4": SSAAnalysisDashboard,
        "EI_1": EILocalEconomyDashboard,
        "EI_2": BenchmarkAnalysisDashboard,
        "EI_3": IndustryAnalysisDashboard,
        "LG_EU": "https://europe-insights.lightcast.io/"
    },
    public: {}
};

export const Languages = [
    {lang: "EN", flag: "united-kingdom.svg", locale: "en-GB"}
    // {lang: "IT", flag: "italy.svg", locale: "it-IT"}
];

